import { render } from "./GlobalLoader.vue?vue&type=template&id=4d9e64b4&scoped=true"
import script from "./GlobalLoader.vue?vue&type=script&lang=js"
export * from "./GlobalLoader.vue?vue&type=script&lang=js"

import "./GlobalLoader.vue?vue&type=style&index=0&id=4d9e64b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9e64b4"]])

export default __exports__